var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{staticClass:"z-5",attrs:{"tabs-class":"!justify-end","items":_vm.items,"sticky":_vm.sticky,"center-active":_vm.centerActive},model:{value:(_vm.activeMenu),callback:function ($$v) {_vm.activeMenu=$$v},expression:"activeMenu"}})}
var staticRenderFns = []

export { render, staticRenderFns }